import { render } from "./DigitalTriplet.vue?vue&type=template&id=42a857d0&scoped=true"
import script from "./DigitalTriplet.vue?vue&type=script&lang=js"
export * from "./DigitalTriplet.vue?vue&type=script&lang=js"

import "./DigitalTriplet.vue?vue&type=style&index=0&id=42a857d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a857d0"]])

export default __exports__